import Tabs from './Tabs.vue'
import Tab from './Tab.vue'

export default {
  Tabs,
  Tab
}



// WEBPACK FOOTER //
// ./src/app/components/common/tabs/index.js